import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  width: 280px;
  padding: 6px 12px 8px;
  border-radius: 8px;
  border: 1px solid ${colors.lightGray16 ?? '#d1d1d1'};
  /* background: ${colors.lightGray18 ?? '#f0f0f0'}; */
  margin-bottom: 10px;
`;

export const PlayerRow = lib.styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
`;

export const PlayButton = lib.styled.button`
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  /* background: ${colors.darkBlue02 ?? '#2C4F9E'}; */
  background: #1264a3;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  padding: 0;
  transition: background 150ms ease;

  &:hover {
    background: #065896;
  }

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const WaveformContainer = lib.styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 2px;
  height: 100%;
  cursor: pointer;
`;

type BarProps = {
  heightRatio: number;
  played: boolean;
};

export const Bar = lib.styled.div<BarProps>`
  flex: 1;
  height: ${(p: BarProps) => Math.max(15, Math.round(p.heightRatio * 100))}%;
  min-height: 4px;
  background: ${(p: BarProps) =>
    p.played ? '#1264a3' : colors.lightGray16 ?? '#d1d1d1'};
  border-radius: 2px;
  transition: background 80ms linear;
`;

export const Duration = lib.styled.span`
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  color: ${colors.darkGray13 ?? '#555'};
  font-variant-numeric: tabular-nums;
  min-width: 32px;
  text-align: right;
`;
